<template>
  <div class="layout my-track">
    <div class="tab_nav">
      <van-tabs v-model="activeName" @click="changeTab"  class="track_tab">
        <van-tab title="展品" name="pro">
          <proList v-if="activeName=='pro'"></proList>
        </van-tab>
        <van-tab title="展商" name="exor">  
          <exorList v-if="activeName=='exor'" ></exorList>
        </van-tab>
        <van-tab title="活动" name="activity">
          <activityList v-if="activeName=='activity'"></activityList>
        </van-tab>
        <van-tab title="话题" name="topic" class="con_bg_f2">
          <topicList v-if="activeName=='topic'"></topicList>
        </van-tab>
        <van-tab title="供需" name="supply" class="con_bg_f2">
          <supplyList v-if="activeName=='supply'"></supplyList>
        </van-tab>
        <van-tab title="资讯" name="news">
          <newsList v-if="activeName=='news'"></newsList>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import proList from "./components/pro-list";  //展品
import exorList from "./components/exor-list";  //展商
import activityList from "./components/activity-list";  //活动
import topicList from "./components/topic-list";  //话题
import supplyList from "./components/supply-list";  //供需
import newsList from "./components/news-list";  //资讯
export default {
  name: "my-contacts",
  components:{
    proList,
    exorList,
    activityList,
    topicList,
    supplyList,
    newsList
  },
  data() {
    return {
      activeName:'',
      headTab:[
        {title: '展品',name:'pro'},
        {title: '展商',name:'exor'},
        {title: '活动',name:'activity'},
        {title: '话题',name:'topic'},
        {title: '供需',name:'supply'},
        {title: '资讯',name:'news'},
      ],
    } 
  },
  async created(){
    this.$store.commit('setExhibitionId',this.$route.params.id);
    if(!this.userInfo){
      await this.$Myapollo.getUserInfo(this);
    }
    this.activeName = this.myTrackHead ||'pro';
  },
  mounted(){
    
  },
  computed: {
    ...mapGetters({
      myTrackHead:'getMyTrackHead',
      userInfo:'getUserInfo'
    }),
  },
  methods:{
    changeTab(name,title){
      this.$store.commit('setMyTrackHead',name);
    },
  }
};
</script>

<style lang="scss" scoped>
.my-track{
  padding-bottom: 0;
  .tab_nav{
    width: 100%;
    // padding-left:0.3rem;
    ::v-deep .track_tab{
      width: 100vw;
      .van-tabs__wrap{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 99;
        height: 0.9rem;
        border-bottom: 1px solid #e6e6e6;
        &::after{
          display: none;
        }
        .van-tabs__nav{
          padding-left:0.3rem;
          padding-bottom: 0;
          .van-tab{
            line-height: initial;
            display: flex;
            flex-basis:initial!important;
            // flex: initial;
            justify-content: center;
            align-items: center;
            width: 1.2rem;
            padding: 0;
            margin-right: 0.1rem;
            .van-tab__text{
              display: flex;
              font-size: 0.26rem;
              color: #666;
              width: 1.2rem;
              height: 0.48rem;
              border-radius: 0.24rem;
              justify-content: center;
              align-items: center;
              
            }  
            &.van-tab--active{
              .van-tab__text{
                background: #1890ff;
                color: #fff;
              }
            }
            &:nth-last-child(2){
              flex-shrink: 0;
              width: 1.5rem;
              .van-tab__text{
                margin-right: 0.3rem;
              }
            }
          }
          .van-tabs__line{
            display: none;
          }
        }
      }
      .van-tabs__content{
        padding-top:0.9rem;
        .con_bg_f2{
          min-height: calc(100vh - 0.9rem);
          background: #f2f2f2;
        }
      }
    }
  }
}
</style>
